module.exports = "/_next/static/images/video_id_7138520141607734574-26ae38f29f98f550c6668bb6e772fbc7.jpg";